export default __webpack_public_path__ + "static/media/zerve_banner.fb767d4a.png";